import React from 'react';
import { useSelector } from 'react-redux';
import EventItem from './EventItem.component';
import { IEvent } from '../../../../Models/DTO/Event.model';
import { useNavigation, Navigate } from '../../../../Hooks';
import { Route } from '~/Constants/Routes.constants';
import { selectLocationById, selectTrainerById } from '../../../../store/provider';
import { selectBookingSummaryForEvent } from '../../../../store/bookings';

const goToDetailCallback = (navigate: Navigate, id: string, eventType: string) => () =>
  navigate(Route.EVENT_DETAILS, { id, eventType });

export const useEventItemContainer = (event: IEvent) => {
  const trainer = useSelector(selectTrainerById(event.trainerIds[0]));
  const location = useSelector(selectLocationById(event.locationId));
  const bookingInformation = useSelector(selectBookingSummaryForEvent(event.id));
  const { navigate } = useNavigation();
  return {
    bookingInformation,
    trainer,
    location,
    goToDetail: goToDetailCallback(navigate, event.id, event.type),
  };
};

interface EventItemContainerProps {
  event: IEvent;
  breakTime?: number;
}

export default function EventItemContainer({ event, breakTime = -1 }: EventItemContainerProps) {
  const { bookingInformation, trainer, location, goToDetail } = useEventItemContainer(event);
  return (
    <EventItem
      bookingInformation={bookingInformation}
      breakTime={breakTime}
      event={event}
      goToDetail={goToDetail}
      location={location}
      trainer={trainer}
    />
  );
}
